import React from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

export const InfoTooltip = ({ title }) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <Info className="ml-1 mr-1 h-4 w-4 text-gray-400" />
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{title}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
